import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

function ExportCSV({ entries, header }) {
  const locationPath = useLocation();
  const [fileName, setFileName] = useState("");

  useEffect(() => {
    setFileName(
      locationPath.pathname.replace("/", "").replace("-", "_") + ".csv"
    );
  }, [locationPath.pathname]);

  const downloadCSV = () => {
    const csvContent =
      "data:text/csv;charset=utf-8," +
      header.map((h) => `"${h}"`).join(",") +
      "\n" +
      entries.map((e) => Object.values(e).join(",")).join("\n");
    const encodedUri = encodeURI(csvContent);
    const link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", fileName);
    document.body.appendChild(link);
    link.click();
  };

  return (
    <button onClick={downloadCSV} id="CSV">
      EXPORT
    </button>
  );
}

export default ExportCSV;
